import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageSupport from "./sections/GarageSupport";
import Gallery from "./sections/Gallery";
import GarageGallery from "./sections/GarageGallery";
import Testimonials from "./sections/Testimonials";
import GarageStats from "./sections/GarageStats";
import GalleryFaq from "./sections/GalleryFaq";
import BusinessMetricsStats from "./sections/BusinessMetricsStats";
import GarageCta from "./sections/GarageCta";
import ServiceAreasMap from "./sections/ServiceAreasMap";
import Footer from "./sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageSupport />
      <Gallery />
      <GarageGallery />
      <Testimonials />
      <GarageStats />
      <GalleryFaq />
      <BusinessMetricsStats />
      <ServiceAreasMap />
      <GarageCta />
      <Footer />
    </div>;
}